<template>
    <div>
        <h4>ที่อยู่สำหรับออกใบภาษี</h4>
        <br>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize text-right">
                จังหวัด
            </label>
            <div class="col-sm-6">
                <multiselect
                        v-model="form.address_tax.province"
                        @input="getDistrictsTax(form.address_tax.province)"
                        :options="optionProvince"
                        :show-labels="false"
                        label="name"
                        placeholder="เลือกเขต / อำเภอ"
                        track-by="name">
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize text-right">
                เขต / อำเภอ
            </label>
            <div class="col-sm-6">
                <multiselect
                        v-model="form.address_tax.district"
                        @input="getSubDistrictsTax(form.address_tax.district)"
                        :options="optionDistricts"
                        :show-labels="false"
                        label="name"
                        placeholder="เลือกเขต / อำเภอ"
                        track-by="name">
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize text-right">
                แขวง / ตำบล
            </label>
            <div class="col-sm-6">
                <multiselect
                        v-model="form.address_tax.sub_district"
                        :options="optionSubDistricts"
                        :show-labels="false"
                        label="name"
                        placeholder="แขวง / ตำบล"
                        track-by="name">
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize text-right">
                รายละเอียดที่อยู่
            </label>
            <div class="col-sm-6">
                <textarea type="text" v-model="form.address_tax.address" class="form-control"/>
            </div>
        </div>
        <div class="col text-center">
            <button @click="submitConfirm"
                    type="button"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon>
                บันทึก</button>&nbsp&nbsp
            <button @click="submitCancel"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>&nbsp;&nbsp;
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import { mapState } from "vuex";
    export default {
        name: "customer-address-tax",
        components: {
            Multiselect
        },
        data(){
          return {

          }
        },
        created(){
            this.$store.dispatch('Customer/setProvince')
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.Customer.CustomerForm ;
                },
                optionProvince:state =>{
                    return state.Customer.provinces;
                },
                optionDistricts:state=>{
                    return state.Customer.districts;
                },
                optionSubDistricts:state=>{
                    return state.Customer.sub_districts;
                }
            }),
        },
        methods:{
            getDistrictsTax(province){
                console.log(province);
                this.form.address_tax.district = null;
                this.form.address_tax.sub_district = null;
                if(province){
                    console.log(province.code);
                    this.$store.dispatch('Customer/setDistrict',province.code)
                }
                else{
                    this.form.address_tax.district = null;
                    this.form.address_tax.sub_district = null;
                }
            },
            getSubDistrictsTax(districts){
                this.form.address_tax.sub_district = null;
                if(districts){
                   this.$store.dispatch('Customer/setSubDistrict',districts.district_id)
                }
                else{
                    this.form.address_tax.sub_district = null;
                }
            },
            submitConfirm(){
                if(this.form.address_tax.province){
                    this.form.address_tax.provinces_id = this.form.address_tax.province.id
                }
                if(this.form.address_tax.district){
                    this.form.address_tax.districts_id = this.form.address_tax.district.id
                }
                if(this.form.address_tax.sub_district){
                    this.form.address_tax.sub_districts_id = this.form.address_tax.sub_district.id
                }
                this.$emit("submit",1)
            },
            submitCancel(){
                this.$emit("submit",0)
            }
        }
    }
</script>

<style scoped>

</style>